import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ACCENT_MARK_CLASS } from '@/styles/accentMark';
import { TABLE_HEADER_BG, TABLE_HEADER_TEXT_CLASS } from '@/styles/dataTableBg';

const TITLE_APPEARANCE_CLASS = {
  plain: 'pt-2.5 pb-1',
  bar: cn('rounded-lg px-2 py-1.5', TABLE_HEADER_BG, TABLE_HEADER_TEXT_CLASS),
} as const;

type SectionTitleAppearance = keyof typeof TITLE_APPEARANCE_CLASS;

interface CompactSectionTitleProps {
  title: string;
  icon: LucideIcon;
  appearance?: SectionTitleAppearance | undefined;
}

export function CompactSectionTitle({
  title,
  icon: Icon,
  appearance = 'plain',
}: CompactSectionTitleProps) {
  return (
    <h2
      className={cn(
        'flex items-center gap-2 text-sm font-semibold',
        TITLE_APPEARANCE_CLASS[appearance],
      )}
    >
      <span
        className={cn(
          'flex size-6.5 shrink-0 items-center justify-center rounded-lg',
          ACCENT_MARK_CLASS,
        )}
      >
        <Icon className="size-3.5" aria-hidden />
      </span>
      {title}
    </h2>
  );
}
